var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IntegrationEventQueue_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { IntegrationType } from './integrationOrgInfo';
export var IntegrationEventType;
(function (IntegrationEventType) {
    IntegrationEventType["Element"] = "element";
    IntegrationEventType["Calculation"] = "calculation";
    IntegrationEventType["LockingCalc"] = "locking_calc";
    IntegrationEventType["ChangeRequest"] = "changeRequest"; // keep for backwards compatibility but no longer used.
})(IntegrationEventType || (IntegrationEventType = {}));
export var IntegrationQueueType;
(function (IntegrationQueueType) {
    IntegrationQueueType["Sqs"] = "sqs";
    IntegrationQueueType["Kinesis"] = "kinesis";
    IntegrationQueueType["SqsDLQ"] = "sqs-dlq";
    IntegrationQueueType["Sns"] = "sns";
})(IntegrationQueueType || (IntegrationQueueType = {}));
const schema = {
    $id: 'urn:wisepipe-domain-authorize:IntegrationEventQueue',
    type: 'object',
    properties: {
        integrationSource: { type: 'string' },
        integrationType: { type: 'string', enum: Object.values(IntegrationType) },
        integrationEventType: { type: 'string', enum: Object.values(IntegrationEventType) },
        sqsQueueUrl: { type: 'string' },
        kinesisStreamArn: { type: 'string' },
        integrationQueueType: { type: 'string', enum: Object.values(IntegrationQueueType) },
        accessorRoleArn: { type: 'string' },
        snsTopicArn: { type: 'string' }
    },
    required: ['integrationSource', 'integrationType'],
    if: { required: ['integrationQueueType'] },
    then: {
        allOf: [
            {
                if: { properties: { integrationQueueType: { const: IntegrationQueueType.Sqs } } },
                then: { required: ['sqsQueueUrl'] }
            },
            {
                if: { properties: { integrationQueueType: { const: IntegrationQueueType.Kinesis } } },
                then: { required: ['kinesisStreamArn'] }
            },
            {
                if: { properties: { integrationQueueType: { const: IntegrationQueueType.Sns } } },
                then: { required: ['snsTopicArn'] }
            }
        ]
    }
};
let IntegrationEventQueue = IntegrationEventQueue_1 = class IntegrationEventQueue {
    constructor(integrationSource, integrationType, integrationEventType, sqsQueueUrl, kinesisStreamArn, integrationQueueType, accessorRoleArn, snsTopicArn) {
        this.integrationSource = integrationSource;
        this.integrationType = integrationType;
        this.integrationEventType = integrationEventType;
        this.sqsQueueUrl = sqsQueueUrl;
        this.kinesisStreamArn = kinesisStreamArn;
        this.integrationQueueType = integrationQueueType;
        this.accessorRoleArn = accessorRoleArn;
        this.snsTopicArn = snsTopicArn;
        JSON.validate(this, IntegrationEventQueue_1);
    }
};
IntegrationEventQueue = IntegrationEventQueue_1 = __decorate([
    JsonSchema(schema)
], IntegrationEventQueue);
export { IntegrationEventQueue };
//# sourceMappingURL=integrationEventQueue.js.map